import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import MainApp from './modules/mainApp/App';
import AiApp from './modules/aiApp/App';

const AiRedirect = () => {
  const location = useLocation();
  // Remove the leading  prefix to get the path for the subdomain
   const newPath = location.pathname.replace(/^\/ai/, '');
  const newUrl = `https://ai.dragonscape.pl${newPath}${location.search}${location.hash}`;

  useEffect(() => {
    // Perform the redirect
    window.location.replace(newUrl);
  }, [newUrl]);

  // Display a message while redirecting
  return <div>Przekierowywanie do aplikacji AI...</div>;
};

function App() {
  const hostname = window.location.hostname;
  const isAiDomain = hostname === 'ai.dragonscape.pl';
  const isMainDomain = hostname === 'dragonscape.pl';

  return (
    <Router>
      <Routes>
        {isAiDomain ? (
          // On ai.dragonscape.pl, only ever show the AiApp
          <Route path="/*" element={<AiApp />} />
        ) : isMainDomain ? (
          // On dragonscape.pl show MainApp and redirect /* to the subdomain
          <>
            <Route path="/ai/*" element={<AiRedirect />} />
            <Route path="/*" element={<MainApp />} />
          </>
        ) : (
          // Fallback for other domains (like localhost)
          // This allows developing both apps on a single domain without redirects
          <>
            <Route path="/ai/*" element={<AiRedirect />} />
            <Route path="/*" element={<AiApp />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;

 // "deploy": "gh-pages -d build",
 //"predeploy": "npm run build"